// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"8908dc7b","348":"9262dd8a","599":"dda62e2f","629":"1f48d519"}[chunkId] + ".chunk.js";
};